module.exports = __webpack_public_path__ + "img/cm.d8947864.svg";